// @flow

import React from 'react'
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'
import { Title } from 'src/theme/globalStyle'
import { Logo } from 'src/components/Icons'
import { PaymentOptions } from 'src/components/PaymentOptions'
import history from 'src/config/history'

const StyledNav = styled.nav`
  width: 99%;
  display: flex;
  justify-content: space-between;
  margin: 80px auto 60px auto;
  z-index: 100;
  align-items: center;
  ${media.phone`
    flex-direction: column;
    display:none
  `};
  ${media.tablet`
    flex-direction: row;
    display: flex;
   `};
  ${media.desktop`
    width: 1024px;
    flex-direction: row;
  `};
`

const RelativeStyledNav = styled.div`
  position: relative;
  z-index: 100;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  ${media.phone`
    margin-bottom:1rem;
  `}
  ${media.tablet`
    margin-bottom:unset;
  `}
`

const AddressBar = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  flex-direction: row;
  ${media.phone`
    padding: 0 20px;
    overflow-y: auto;
    margin: 0 auto;
  `}
  ${media.desktop`
    padding: 10px 0;
    width: 1024px;
  `}
  ${media.giant`
    padding: 10px 0;
    width: 1024px;
  `}
`

const LHSa = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > :first-child {
    margin: 0 0 20px 0;
  }
  ${media.phone`
    width: auto;
    flex-direction: row;
    & > :first-child {
      margin: 0 20px 0 0;
    }
  `};
`

const LHS = styled.div`
  display: flex;
  align-items: left;
  & > :first-child {
    margin: 0 0 20px 0;
  }
  ${media.phone`
    width: 100%;
    flex-direction: row;
    justify-content: center;
    & > :first-child {
      margin: 0 20px 0 0;
    }
  `};
  ${media.tablet`
    flex-direction: row;
    width: 45%;
    padding-left: 10px;
    justify-content: left;
  `};
  ${media.tabletLarge`
    justify-content: left;
    padding-left: 10px;
    flex-direction: column;
  `};
`
const RHS = styled.div`
  ${media.phone`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin-top: 50px;
  `};
  ${media.tablet`
    display: flex;
    flex-direction: row;
    width: 38%;
    margin-top: 0;
  `};
  ${media.tabletLarge`
    display: flex;
    flex-direction: column;
    padding-right: 20px
    width: 38%;
    margin-top: 0;
  `};
  ${media.desktop`
    padding-right: 0;
  `};
`

const RHSa = styled.div`
  ${media.phone`
    display: none;
    flex-direction: row;
    align-items: center;
  `};
  ${media.desktop`
    padding-top: 10px;
    flex-direction: column;
  `};
`

const StyleDiv = styled.div`
  &:hover {
    cursor: pointer;
  }
`

export const NavBar = ({ title, noTopBar }: { title: string, noTopBar?: boolean }) => {
  const onClickGoBack = () => {
    history.goBack()
  }
  return (
    <RelativeStyledNav>
      {!noTopBar && (
        <AddressBar>
          <LHSa>
            <Logo />
            <StyleDiv onClick={onClickGoBack}>{'< Go Back'}</StyleDiv>
          </LHSa>
          <RHSa>{'Call us on +44 020 3960 8784'}</RHSa>
        </AddressBar>
      )}
      <StyledNav>
        <LHS>
          <Title noMargin>{title}</Title>
        </LHS>
        <RHS>
          <PaymentOptions isWide={true} />
        </RHS>
      </StyledNav>
    </RelativeStyledNav>
  )
}



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js